import 'jquery';

$(() => {
    $('.input-group-button-increment').on('click', (ev) => {
        var $button = $(ev.target);
        var $input = $button.parents('.input-number-group').find('.input-number');
        var number = parseInt($input.val() || $input.attr('placeholder'), 10) + 1;
        var max = parseInt($input.attr('max') || 100, 10);

        if (number <= max) {
            $input.val(number);
            $input[0].dispatchEvent(new InputEvent('input'));
            $button.prop('disabled', false);
        } else {
            $button.prop('disabled', true);
        }
    });

    $('.input-group-button-decrement').on('click', (ev) => {
        var $button = $(ev.target);
        var $input = $button.parents('.input-number-group').find('.input-number');
        var number = parseInt($input.val() || $input.attr('placeholder'), 10) -1;
        var min = parseInt($input.attr('min') || 0, 10);

        if (number >= min) {
            $input.val(number);
            $input[0].dispatchEvent(new InputEvent('input'));
            $button.prop('disabled', false);
        } else {
            $button.prop('disabled', true);
        }
    });

    $('.input-number').on('input', (ev) => {
        toggleInputNumberButtons($(ev.target));
    }).each((index, el) => {
        toggleInputNumberButtons($(el));
    });
});

function toggleInputNumberButtons($input) {
    var $group = $input.parents('.input-number-group');
    var $decrement = $group.find('.input-group-button-decrement');
    var $increment = $group.find('.input-group-button-increment');

    var number = parseInt($input.val() || $input.attr('placeholder'), 10);
    var min = parseInt($input.attr('min') || 0, 10);
    var max = parseInt($input.attr('max') || 100, 10);

    $decrement.prop('disabled', number <= min);
    $increment.prop('disabled', number >= max);
}
